
import React from 'react';
import { X, Minimize2, Maximize2, MessageSquare } from 'lucide-react';
import ChatbotAvatar from './ChatbotAvatar';

interface ChatHeaderProps {
  isMinimized: boolean;
  useTelegram: boolean;
  onToggleMinimize: () => void;
  onToggleChat: () => void;
  onToggleTelegram: () => void;
  chatId?: string; // Add the chatId property as optional
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  isMinimized,
  useTelegram,
  onToggleMinimize,
  onToggleChat,
  onToggleTelegram,
  chatId
}) => {
  return (
    <div className="bg-primary text-white p-4 flex justify-between items-center">
      <div className="flex items-center">
        <ChatbotAvatar size="small" />
        <h3 className="font-medium text-sm ml-2">Manon - Assistante CV Pro</h3>
      </div>
      <div className="flex items-center space-x-2">
        {chatId && (
          <small className="text-xs opacity-60 mr-2" title={`Chat ID: ${chatId}`}>
            ID: {chatId.substring(0, 4)}...
          </small>
        )}
        <button
          onClick={onToggleTelegram}
          className={`text-white p-1 rounded-full transition-colors ${
            useTelegram ? 'bg-white/30' : 'hover:bg-white/20'
          }`}
          aria-label={useTelegram ? "Utiliser le chat web" : "Utiliser Telegram"}
          title={useTelegram ? "Mode Telegram activé" : "Passer en mode Telegram"}
        >
          <MessageSquare size={16} />
        </button>
        <button
          onClick={onToggleMinimize}
          className="text-white hover:bg-white/20 p-1 rounded-full transition-colors"
          aria-label={isMinimized ? "Maximize chat" : "Minimize chat"}
        >
          {isMinimized ? <Maximize2 size={16} /> : <Minimize2 size={16} />}
        </button>
        <button
          onClick={onToggleChat}
          className="text-white hover:bg-white/20 p-1 rounded-full transition-colors"
          aria-label="Close chat"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
